export default {
    BOSNIA_AND_HERZEGOVINA: 'bosnia_and_herzegovina',
    TOTAL_PHARMACIES: 'total_pharmacies',
    ALL_LOCATIONS: 'all_locations',
    PHARMACY_LOCATIONS: 'pharmacy_locations',
    TOTAL_POSITIONS: 'total_positions',
};
